module.exports = __webpack_public_path__ + "img/nohandle@2x copy.38d9eacb.png";